export const urls = {
  VARATI_STAVKE: 'StavkeNaRadnomNalogu/vrati_StavkeNaRadnomNalogu',
  DELETE_STAVKE: 'StavkeNaRadnomNalogu/brisanje_StavkeNaRadnomNalogu',
  INSERT_STAVKE: 'StavkeNaRadnomNalogu/unos_StavkeNaRadnomNalogu',
  UPDATE_STAVKE: 'StavkeNaRadnomNalogu/izmena_StavkeNaRadnomNalogue',
};
